import angular from 'angular';
import generalBusinessComponent from './general-business.component';

let generalBusinessModule = angular.module('generalBusiness', [])
  .component('generalBusiness', generalBusinessComponent);

export default generalBusinessModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/general-business/general-business.js